import '@babel/polyfill';

import fontawesome from '@fortawesome/fontawesome';
import { faGithub, faLinkedin, faTwitter } from '@fortawesome/fontawesome-free-brands';
import { faChevronDown } from '@fortawesome/fontawesome-free-solid';
import MobileDetect from 'mobile-detect';
import Vue from 'vue';
import {
  transitions,
  VApp,
  VAvatar,
  VBtn,
  VForm,
  VGrid,
  VParallax,
  VSnackbar,
  VTextarea,
  VTextField,
  VTooltip,
  Vuetify,
} from 'vuetify';
import webfontloader from 'webfontloader';

import App from './App';
/* import router from './router'; */

require('../node_modules/vuetify/src/stylus/app.styl');

webfontloader.load({
  google: {
    families: ['Roboto:300,400,700'],
  },
});

if (!process.env.NODE_ENV === 'production') {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

fontawesome.library.add(faLinkedin, faGithub, faTwitter, faChevronDown);

Vue.use(Vuetify, {
  components: {
    Vuetify,
    VApp,
    VGrid,
    VParallax,
    VAvatar,
    VSnackbar,
    VForm,
    VBtn,
    VTextField,
    VTextarea,
    VTooltip,
    transitions,
  },
  theme: {
    primary: '#fff',
  },
});

const getHeight = () => document.documentElement.clientHeight;
const MD = new MobileDetect(window.navigator.userAgent);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  /* router, */
  template: '<App :winHeight="winHeight" :mobile="mobile" />',
  components: { App },
  data() {
    return { winHeight: getHeight(), mobile: !!MD.mobile() };
  },
  watch: {
    winHeight(v) {
      this.winHeight = v;
    },
  },
  mounted() {
    const resizeHandler = () => {
      this.winHeight = getHeight();
      return true;
    };

    resizeHandler();
    window.addEventListener('resize', () => resizeHandler());
  },
});



// WEBPACK FOOTER //
// ./src/main.js